import React from 'react';
import { Container } from 'react-bootstrap';
import Event from '../../../Utilitis/Event/Event';
import Section from '../../../Utilitis/Section';
import TitleSection from '../../../Utilitis/TitleSection';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';



export default function UpcomingEvent(props) {
    return (
        <Section bg="#f3f7f9">
            <Container>
                <TitleSection text="Upcoming Events " center title />
                <OwlCarousel className='owl-theme' {...props.option}  >
                    <div className='item'> <Event title="Student Award 2021" image="/images/post01.jpg" /> </div>
                    <div className='item'> <Event title="Introduction to Human Nutrition 2021" image="/images/post02.jpg" /> </div>
                    <div className='item'> <Event  title="Working with Students with Special " image="/images/post03.jpg" /> </div>
                    <div className='item'> <Event title="Introduction to Human Nutrition 2021" image="/images/post02.jpg" /></div>
                    <div className='item'> <Event title="Student Award 2021" image="/images/post01.jpg" /></div>
                </OwlCarousel>;
            </Container>
        </Section>
    )
}
